import React, { useState } from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { s3baseUrl } from "src/config/config";
import ReactPlayer from "react-player";
import CustomPopover from "src/components/CustomPopover";
import { Icon } from "@iconify/react";
import { bms_date_format, show_proper_words } from "src/utils/constants";

const getIconByType = (video) => {
  const { practice_type, library_type } = video;

  if (practice_type === "workout" || library_type === "workout-type") {
    return "mdi:gym";
  } else if (practice_type === "food" || library_type === "meal-type") {
    return "fluent:food-24-filled";
  } else if (practice_type === "mindset" || library_type === "mindset-type") {
    return "flowbite:brain-outline";
  } else if (practice_type === "video") {
    return "lets-icons:video-fill";
  }
  return "";
};

const VideoLibraryCard = ({ videos }) => {
  const [open, setOpen] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState("");

  const handleOpen = (url) => {
    setCurrentVideoUrl(url.video_url);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentVideoUrl("");
  };

  const MENU_OPTIONS = [
    {
      label: "Watch Now",
      icon: "bx:detail",
      handleClick: handleOpen,
    },
  ];

  return (
    <div className="container mt-4">
      <div className="row">
        {videos.map((video, index) => (
          <div
            className="col-md-4 mb-4 d-flex justify-content-center"
            key={index}
          >
            <Card
              sx={{
                borderRadius: 1,
                boxShadow: 3,
                width: "100%",
                position: "relative",
                overflow: "hidden",
              }}
              className="video-card pointer"
            >
              <div className="programmes-menu-option">
                <CustomPopover menu={MENU_OPTIONS} data={video} />
              </div>
              <div className="video-thumbnail-wrapper position-relative">
                <CardMedia
                  component="img"
                  height="180"
                  image={s3baseUrl + video?.video_thumbnail?.thumbnail_1}
                  alt={video?.title}
                />

                <div className="overlay d-flex align-items-center justify-content-center">
                  <Button variant="contained" onClick={() => handleOpen(video)}>
                    Watch Now
                  </Button>
                </div>
              </div>
              <CardContent>
                <Typography
                  gutterBottom
                  variant="h6"
                  className="d-flex align-items-center gap-2"
                >
                  {video?.title}
                  {video?.workout_completed && (
                    <Tooltip title="Your Workout is Completed">
                      <span
                        className="material-icons ms-2"
                        style={{ fontSize: 18 }}
                      >
                        <Icon
                          icon="fluent-mdl2:completed-solid"
                          color="green"
                        />
                      </span>
                    </Tooltip>
                  )}
                </Typography>
                <Typography variant="body2">
                  Task Date: {bms_date_format(video?.workout_date)}
                </Typography>{" "}
                <Typography variant="body2">
                  Task Type:{" "}
                  {show_proper_words(
                    video?.practice_type == "food"
                      ? "Nutrition"
                      : video?.practice_type
                  )}
                  <span
                    className="material-icons ms-2"
                    style={{ fontSize: 18 }}
                  >
                    <Icon icon={getIconByType(video)} color="#04abbb" />
                  </span>
                </Typography>
              </CardContent>
            </Card>
          </div>
        ))}
      </div>
      <Dialog open={open} maxWidth="md" fullWidth scroll="body">
        <DialogContent
          className="p-0 position-relative"
          sx={{
            overflow: "hidden",
            padding: 0,
            height: "auto",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              zIndex: 2,
              backgroundColor: "#04abbb",
              "&:hover": {
                backgroundColor: "#04abbb",
              },
            }}
          >
            <CloseIcon
              style={{
                fill: "#fff",
                fontSize: "12px",
              }}
            />
          </IconButton>
          {open && currentVideoUrl && (
            <ReactPlayer
              url={currentVideoUrl}
              width="100%"
              height="450px"
              controls
              playsinline
              playing
              muted
              onEnded={() => setOpen(false)}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default VideoLibraryCard;
